<div
  class="flex justify-between bg-white gap-[21.5px] md:gap-2 items-center flex-wrap pt-3 md:pt-0"
>
  <div class="tf-dates flex items-center gap-2 w-full md:w-[unset]">
    <mat-form-field
      class="w-[48%] md:w-[110px] [&>.mat-form-field-wrapper]:pb-0 removeInputPadding"
      appearance="outline"
    >
      <mat-label i18n="@@start_date" for="startDate">Start Date</mat-label>
      <input
        (dateChange)="dateListner()"
        [formControl]="startDateCtrl"
        name="startDate"
        [min]="startDateRange.min"
        [max]="startDateRange.max"
        readonly
        matInput
        [matDatepicker]="startDate"
        placeholder="Start Date"
        i18n-placeholder="@@start_date"
      />
      <mat-datepicker-toggle matSuffix [for]="startDate">
      </mat-datepicker-toggle>
      <mat-datepicker #startDate></mat-datepicker>
    </mat-form-field>

    <mat-form-field
      class="w-[48%] md:w-[110px] [&>.mat-form-field-wrapper]:pb-0 removeInputPadding"
      appearance="outline"
    >
      <mat-label i18n="@@end_date" for="endDate">End Date</mat-label>
      <input
        (dateChange)="dateListner()"
        [formControl]="endDateCtrl"
        name="endDate"
        [min]="endDateRange.min"
        [max]="endDateRange.max"
        readonly
        matInput
        [matDatepicker]="endDate"
        placeholder="End Date"
        i18n-placeholder="@@end_date"
      />
      <mat-datepicker-toggle matSuffix [for]="endDate"> </mat-datepicker-toggle>
      <mat-datepicker #endDate></mat-datepicker>
    </mat-form-field>
  </div>

  <div class="tf-selects flex flex-wrap items-center gap-2 sm:mb-3">
    <div class="md:w-[150px] w-[31%] removeMatWrapperPadding">
      <app-area-search-select
        [disabled]="!hasPermission([permissions.CAN_VIEW_OTHER_AREAS])"
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.AREA, $event)"
        [control]="getAreaCtrl"
        [type]="type"
      >
      </app-area-search-select>
    </div>
    <div class="md:w-[150px] w-[31%] removeMatWrapperPadding">
      <app-branch-search-select
        [disabled]="
          !hasPermission([
            permissions.CAN_VIEW_OTHER_BRANCHES,
            permissions.CAN_VIEW_OTHER_AREAS,
          ])
        "
        (emitSelectedVal)="emitSelectedVal(reportInputTypes.BRANCH, $event)"
        [control]="getBranchCtrl"
        [areaId]="selectedAreaId"
        [type]="type"
      ></app-branch-search-select>
    </div>
    <!-- Always shown: with no branch picked the list falls back to the area's
         officers, or all of them. It used to be hidden until a branch was
         chosen, which also hid a still-applied officer filter after switching
         Branch back to All. showDefaultListValue renders the "All" option, so
         the default (0) reads "All" like Area and Branch instead of blank. -->
    <div class="md:w-[150px] w-[31%] removeMatWrapperPadding sm:col-span-3">
      <app-loan-officer-search-select
        [disabled]="
          !hasPermission([
            permissions.CAN_VIEW_OTHER_LOANOFFICERS,
            permissions.CAN_VIEW_OTHER_AREAS,
            permissions.CAN_VIEW_OTHER_BRANCHES,
          ])
        "
        (emitSelectedVal)="
          emitSelectedVal(reportInputTypes.LOAN_OFFICER, $event)
        "
        [showDefaultListValue]="true"
        [control]="getLoanOfficerCtrl"
        [branchId]="selectedBranchId"
        [areaId]="selectedAreaId"
        [type]="type"
      ></app-loan-officer-search-select>
    </div>
    <div class="md:w-[120px] w-[31%] removeMatWrapperPadding">
      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <mat-label i18n="@@currency">Currency</mat-label>
        <mat-select [formControl]="currencyCtrl">
          <mat-option value="" i18n="@@all">All</mat-option>
          <mat-option value="NGN">NGN</mat-option>
          <mat-option value="USD">USD</mat-option>
          <mat-option value="GBP">GBP</mat-option>
          <mat-option value="EUR">EUR</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <app-button-icon-ui
      class="w-full md:w-[unset] reset-btn pt-3 md:pt-0"
      [buttonType]="'button'"
      classNames="p-3  rounded-xl border-primary text-primary hover:opacity-100 md:w-[80px] w-full md:float-right"
      (clickEmit)="reset()"
      i18n-name="@@reset"
      name="Reset"
      value="cancel"
    ></app-button-icon-ui>
  </div>
</div>
